import type PaginatedResponse from '@/types/PaginatedResponse'
import { http } from '../plugins/http'
import type { AxiosResponse } from 'axios'

import type DataResponse from '@/types/DataResponse'
import type MessageResponse from '@/types/MessageResponse'
import type PointOfSale from '@/types/PointOfSale'
import { useProducerStore } from '@/stores/producer'
import ModelService from '@/contracts/ModelService'

export default class PointOfSaleService extends ModelService<PointOfSale> {
  async index(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<PointOfSale>>> {
    const producer = useProducerStore().producer

    return await http.get<PaginatedResponse<PointOfSale>>(
      `/api/v1/office/producers/${producer?.id}/points-of-sale?page=${page}&${filters}&per_page=${per_page}`,
    )
  }

  async show(id: string) {
    const producer = useProducerStore().producer

    return await http.get<DataResponse<PointOfSale>>(`/api/v1/office/producers/${producer?.id}/points-of-sale/${id}`)
  }

  async update(id: string, model: PointOfSale) {
    const producer = useProducerStore().producer

    const data = {
      ...model,
    }

    return await http.put<DataResponse<PointOfSale>>(
      `/api/v1/office/producers/${producer?.id}/points-of-sale/${id}`,
      data,
    )
  }

  async destroy(model: PointOfSale) {
    const producer = useProducerStore().producer

    return await http.delete<MessageResponse>(
      `/api/v1/office/producers/${producer?.id}/points-of-sale/${model.id}`,
    )
  }

  async store(model: PointOfSale) {
    const producer = useProducerStore().producer

    return await http.post<DataResponse<PointOfSale>>(
      `/api/v1/office/producers/${producer?.id}/points-of-sale`,
      model,
    )
  }
}
